import type { OperationVariables } from '@apollo/client/core';
import type { UseQueryReturn } from '@vue/apollo-composable';

type ValueOf<Obj> = Obj[keyof Obj];

type MaybeString<T> = T | string;

type LiteralOrString<T extends readonly string[]> = T[number] | (string & {});

type GetQueriesType<T, K extends OperationVariables> = Pick<
  UseQueryReturn<T, K>,
  'result' | 'loading' | 'refetch'
>;

type ComponentPropsWithoutModelValue<
  T extends abstract new (...args: any) => any,
> = Omit<InstanceType<T>['$props'], 'modelValue'>;

type ComponentProps<T extends abstract new (...args: any) => any> =
  InstanceType<T>['$props'];

/**
 * Converts an array of key-value pairs into a type-safe object.
 * @param entries - The array of key-value pairs.
 * @returns A type-safe object created from the entries.
 */
function TypeSafeObjectFromEntries<
  const T extends ReadonlyArray<readonly [PropertyKey, unknown]>,
>(entries: T): { [K in T[number] as K[0]]: K[1] } {
  return Object.fromEntries(entries) as { [K in T[number] as K[0]]: K[1] };
}

export type {
  ValueOf,
  MaybeString,
  LiteralOrString,
  ComponentPropsWithoutModelValue,
  ComponentProps,
  GetQueriesType,
};

export { TypeSafeObjectFromEntries };
